module.exports = __webpack_public_path__ + "static/media/Scan.809671c3.jpeg";